@import "../../../../shared/scss";

:host {
  .button-container {
    display: flex;

    @include pds-media-query-min-max("base", "xs") {
      flex-direction: column;
      justify-content: space-between;
    }

    @include pds-media-query-min-max("s", "l") {
      flex-direction: column;
      justify-content: space-between;
    }

    .login {
      padding-block: p-px-to-rem(36px) p-px-to-rem(16px);
      padding-inline: 0;

      @include pds-media-query-min-max("base", "s") {
        inline-size: 100%;
        padding-block-start: 0;
      }

      @include pds-media-query-min-max("s", "l") {
        padding-block: 0;
        padding-inline: 0;
        padding-block-end: p-px-to-rem(16px);
      }

      @include pds-media-query-min-max("l", "xl") {
        padding-block: 0 p-px-to-rem(23px);
        padding-inline: 0 p-px-to-rem(8px);
      }

      @include pds-media-query-min("xl") {
        padding-block: 0 p-px-to-rem(23px);
        padding-inline: 0 p-px-to-rem(8px);
      }
    }

    .more {
      padding-block: 0;
      padding-inline: 0;
      padding-block-end: p-px-to-rem(16px);

      @include pds-media-query-min-max("base", "s") {
        inline-size: 100%;
      }

      @include pds-media-query-min("xs") {
        padding-block: 0 p-px-to-rem(16px);
        padding-inline: p-px-to-rem(8px) 0;
      }

      @include pds-media-query-min("s") {
        padding-block: 0;
        padding-inline: 0;
        padding-block-end: p-px-to-rem(23px);
      }

      @include pds-media-query-min("xl") {
        padding-block: 0 p-px-to-rem(23px);
        padding-inline: 0 p-px-to-rem(16px);
      }
    }
  }

  phn-p-text {
    padding-block-end: p-px-to-rem(24px);
    border-block-end: 2px solid $pds-theme-light-contrast-low;
    margin-block-end: p-px-to-rem(10px);
  }

  phn-p-link-pure {
    float: inline-start;
    text-decoration: underline;
    color: black;
  }
}
